module.exports = __webpack_public_path__ + "static/media/home-hero--bg-sf.c30b3588.jpg";